import { combineReducers } from 'redux';
import { get } from 'lodash';

import {
  REMOVE_CART_SUCCESS,
  REMOVE_CART_FAILURE,
  ADD_ITEM_TO_CART,
  REMOVE_CART_ITEM_SUCCESS,
  SERVICE_FAILURE,
  ADD_ITEM_TO_CART_SUCCESS,
  UPDATE_CART_SUCCESS,
  ADD_ITEM_TO_CART_FAILURE,
  REMOVE_CART_ITEM_FAILURE,
  UPDATE_CART_FAILURE,
  REQUEST_QUOTE_SUCCESS,
  RESET_CART_ERROR_MESSAGE,
  QUOTE_DETAIL_FAILURE,
  SHARE_CART_SUBMIT_SUCCESS,
  SHARE_CART_CLEAR,
  SHARE_CONFIRMATION_SUBMIT_SUCCESS,
  SHARE_CONFIRMATION_CLEAR,
} from './ShoppingCart.constants';

const initState = {};

export const getFailure = (state = initState, error = {}) => ({
  ...state,
  ...{ error, isCartRemoved: false },
});

export const shoppingCartNotRemoved = (state = initState, error = {}) => ({
  ...state,
  ...error,
  ...{ isCartRemoved: false },
});

export const shoppingCartRemoved = (state = initState, data = {}) => ({
  ...state,
  ...data,
  ...{ isCartRemoved: true, entries: [], totalItems: 0, error: null },
});

export const shoppingCartItemRemoved = (state = initState, data = {}) => ({
  ...state,
  ...data,
  ...{ error: null, isCartItemRemoved: true },
});

export const addItemToCartSuccess = (state = initState) => ({
  ...state,
  ...{ isCartItemAdded: true, isCartItemRemoved: false },
});

export const addItemToCart = (state = initState) => ({
  ...state,
  ...{ isCartItemAdded: false, error: null, isCartItemRemoved: false },
});

export const updateCartSuccess = (state = initState) => ({
  ...state,
  ...{ isCartItemAdded: false, error: null, isCartItemRemoved: false },
});

export const updateQuoteSuccess = (state = initState, data = {}) => ({
  ...state,
  ...{ requestQuoteData: data },
});

export const shareCartSuccess = (state = initState, data = {}) => ({
  ...state,
  shareCart: { ...data },
});

export const shareConfirmationSuccess = (state = initState, data = {}) => ({
  ...state,
  shareConfirmationData: { ...data },
});
export const setUserDetails = (state = initState, data = {}) => ({
  ...state,
  ...{ userDetails: data },
  ...{ isCheckoutDataAvailable: true },
});

// eslint-disable-next-line complexity
export const shoppingCartData = (state = initState, action = {}) => {
  switch (action.type) {
    case SERVICE_FAILURE:
    case ADD_ITEM_TO_CART_FAILURE:
    case REMOVE_CART_ITEM_FAILURE:
    case UPDATE_CART_FAILURE:
    case QUOTE_DETAIL_FAILURE:
      return getFailure(state, get(action, 'data', {}));
    case ADD_ITEM_TO_CART:
      return addItemToCart(state);
    case ADD_ITEM_TO_CART_SUCCESS:
      return addItemToCartSuccess(state);
    case REMOVE_CART_FAILURE:
      return shoppingCartNotRemoved(state, get(action, 'error', {}));
    case REMOVE_CART_SUCCESS:
      return shoppingCartRemoved(state, get(action, 'data', {}));
    case REMOVE_CART_ITEM_SUCCESS:
      return shoppingCartItemRemoved(state, get(action, 'data', {}));
    case UPDATE_CART_SUCCESS:
    case RESET_CART_ERROR_MESSAGE:
      return updateCartSuccess(state);
    case REQUEST_QUOTE_SUCCESS:
      return updateQuoteSuccess(state, get(action, 'data', {}));
    case SHARE_CART_SUBMIT_SUCCESS:
      return shareCartSuccess(state, get(action, 'data', {}));
    case SHARE_CART_CLEAR:
      return shareCartSuccess(state, get(action, 'data', {}));
    case SHARE_CONFIRMATION_SUBMIT_SUCCESS:
      return shareConfirmationSuccess(state, get(action, 'data', {}));
    case SHARE_CONFIRMATION_CLEAR:
      return shareConfirmationSuccess(state, get(action, 'data', {}));
    default:
      return state;
  }
};

export default combineReducers({
  shoppingCartData,
});
